import { render, staticRenderFns } from "./CustomerInsuranceBreakdownCover.vue?vue&type=template&id=a16ebf0c"
import script from "./CustomerInsuranceBreakdownCover.vue?vue&type=script&lang=js"
export * from "./CustomerInsuranceBreakdownCover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports